import Vue from 'vue'
import VueRouter from 'vue-router'
import routes from './routers'
import store from '@/store'

Vue.use(VueRouter)

const router = new VueRouter({
	mode: 'history',
	scrollBehavior: () => ({
		y: 0
	}),
	routes
})

router.beforeEach(async (to, from, next) => {
	// if (to.query.inviteCode) {
	// 	storage.set('HTH_MOBILE_INVITE_CODE', to.query.inviteCode)
	// }
	let token = store.state.user.token
	if (['/login', '/register'].includes(to.path)) return next()
	if (token) return next()
	next({ replace: true, path: '/login', query: { redirect: to.fullPath } })
})
router.afterEach(() => {
	window.scrollTo(0, 0)
})

export default router
